import { apiClient } from "./client";

export const hypervisorAPI = {
  getHypervisors() {
    return apiClient.get(`/v2/hypervisors`);
  },
  getHypervisorSummary() {
    return apiClient.get(`/v2/hypervisors/summary`);
  },
  getHypervisorHostname(hostname) {
    return apiClient.get(`/v2/hypervisors/${hostname}`);
  },
};
